// pages/UnderConstruction/UnderConstruction.jsx
import { Construction } from "lucide-react";

const UnderConstruction = ({ title }) => (
    <div className="flex flex-col items-center justify-center h-full text-center text-gray-700 dark:text-gray-200 p-6">
        <Construction size={60} className="mb-4 text-yellow-500" />
        <h1 className="text-3xl font-bold mb-2">Módulo en construcción</h1>
        <p className="text-gray-500 dark:text-gray-400">
            {title ? `"${title}" estará disponible próximamente.` : "Esta sección estará disponible próximamente."}
        </p>
    </div>
);

export default UnderConstruction;